import clsx from 'clsx'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

import ToastClose from 'assets/icons/ToastClose.svg'
import ToastSuccess from 'assets/icons/ToastSuccess.svg'
import { createPortalContainer } from 'utils/createPortalContainer'

import styles from './Toast.module.scss'

interface ToastProps {
  message: string
  isVisible: boolean
  onClose: () => void
  variant?: 'success' | 'error'
}

export const Toast = ({ message, isVisible, onClose, variant = 'success' }: ToastProps) => {
  const [container] = useState(createPortalContainer)

  useEffect(() => {
    document.body.appendChild(container)
    return () => {
      document.body.removeChild(container)
    }
  }, [container])

  if (!isVisible) return null

  return ReactDOM.createPortal(
    <div className={clsx(styles.toast, variant === 'error' && styles.toastError)} role="status" aria-live="polite">
      <div className={styles.message}>
        {variant === 'success' ? (
          <span className={styles.icon}>
            <img src={ToastSuccess} alt="" width={16} height={16} />
          </span>
        ) : null}
        <p className={styles.text}>{message}</p>
      </div>
      <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Dismiss notification">
        <img src={ToastClose} alt="" width={20} height={20} />
      </button>
    </div>,
    container,
  )
}
